import UserContainer from 'documents-ui/lib/containers/UserContainer';
import GateContainer from 'documents-ui/lib/containers/GateContainer';
const hasScope = scope => {
  const user = UserContainer.get();
  return user && user.scopes && user.scopes.indexOf(scope) !== -1;
};
export const hasGate = gateName => {
  const gates = GateContainer.get();
  return gates && gates.includes(gateName);
};
export const getScopes = () => UserContainer.get().scopes;
const getUserId = () => UserContainer.get().user_id;
export const hasDocuments = () => hasScope('documents-read-access') || hasScope('documents-limited-read-access');
export const hasHigherDocumentsLimit = () => hasScope('documents-read-access');
export const canWrite = () => hasScope('documents-limited-write-access');
const isSuperAdmin = () => hasScope('super-admin');
export const canEditObjectPermissions = ownerId => isSuperAdmin() || getUserId() === ownerId;
export const isJitaUser = () => hasScope('jita-user');